var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTablet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_tablet") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_tablet",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_IPad-Pro_2554674",
    transform: "translate(20.000000, 15.000000)",
    fill: "#000000",
    fillRule: "nonzero",
    stroke: "#000000",
    strokeWidth: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8421053,5.60773481 L21,5.60773481 L21,7.53038674 L20.8421053,7.53038674 L20.8421053,27.718232 C20.8421053,28.4261329 20.2765702,29 19.5789474,29 L1.26315789,29 C0.565535053,29 0,28.4261329 0,27.718232 L0,1.44198895 C0,0.734088055 0.565535053,0.160220994 1.26315789,0.160220994 L16.4210526,0.160220994 L16.4210526,0 L18.3157895,0 L18.3157895,0.160220994 L19.5789474,0.160220994 C20.2765702,0.160220994 20.8421053,0.734088055 20.8421053,1.44198895 L20.8421053,2.72375691 L21,2.72375691 L21,4.64640884 L20.8421053,4.64640884 L20.8421053,5.60773481 Z M1.26315789,1.12154696 C1.0887522,1.12154696 0.947368421,1.26501373 0.947368421,1.44198895 L0.947368421,27.718232 C0.947368421,27.8952073 1.0887522,28.038674 1.26315789,28.038674 L19.5789474,28.038674 C19.7533531,28.038674 19.8947368,27.8952073 19.8947368,27.718232 L19.8947368,1.44198895 C19.8947368,1.26501373 19.7533531,1.12154696 19.5789474,1.12154696 L1.26315789,1.12154696 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTablet);
export default __webpack_public_path__ + "static/media/icon_tablet.51db55df996dd7dc822106ca0b68f160.svg";
export { ForwardRef as ReactComponent };